import React from 'react';
import Image from '../AppImage';
import Icon from '../AppIcon';

const VendorCard = ({ vendor, onClick }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(vendor);
        }
    };

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
            e?.preventDefault();
            handleClick();
        }
    };

    return (
        <article
            className="vendor-card"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label={`View details for ${vendor?.name}`}
        >
            <Image
                src={vendor?.image}
                alt={`${vendor?.name} - ${vendor?.category}`}
                className="vendor-card-image"
                loading="lazy"
            />
            <div className="vendor-card-content">
                <div className="vendor-card-header">
                    <h3 className="vendor-card-title">{vendor?.name}</h3>
                    <div className="vendor-card-rating">
                        <Icon name="Star" size={14} />
                        <span>{vendor?.rating?.toFixed(1)}</span>
                    </div>
                </div>

                <p className="vendor-card-category">{vendor?.category}</p>

                <p className="vendor-card-description">{vendor?.description}</p>

                <div className="vendor-card-footer">
                    <div>
                        <div className="vendor-card-price">₹{vendor?.price?.toLocaleString()}</div>
                        <div className="vendor-card-price-label">Starting from</div>
                    </div>
                    <Icon name="ChevronRight" size={20} color="var(--color-primary)" />
                </div>
            </div>
        </article>
    );
};

export default VendorCard;